import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const LOGO_IMAGE = "/assets/images/logo1.png";
const SECOND_LOGO = "/assets/images/logo2.png";

const SLIDE_ONE_BG = "/assets/images/bg1.jpeg";
const SLIDE_TWO_BG = "/assets/images/bg2.jpeg";
const SLIDE_THREE_BG = "/assets/images/bg3.jpeg";
const SLIDE_FOUR_BG = "/assets/images/md.jpeg";

const MD_IMAGE = "/assets/images/md2.jpeg";

const ogfzaSlides = [
  {
    id: 1,
    kind: "full-logo",
    image: SLIDE_ONE_BG,
    overlayText: "",
  },
  {
    id: 2,
    kind: "investor",
    image: SLIDE_TWO_BG,
    overlayText: "Become a Free Zone Investor",
  },
  {
    id: 3,
    kind: "incentives",
    image: SLIDE_THREE_BG,
    overlayText: "A Variety of Incentives Await You",
  },
  {
    id: 4,
    kind: "md-message",
    image: SLIDE_FOUR_BG,
    overlayText: "MD’s Message",
  },
];

const SlideBackground = ({ slide, active }) => {
  // ================= LOGO SECTION =================
  if (slide.kind === "full-logo") {
    return (
      <div className="absolute inset-0 overflow-hidden">
        <img
          src={slide.image}
          alt="OGFZA Background"
          className={`absolute inset-0 w-full h-full object-cover object-center ${
            active ? "kb-zoom-soft" : ""
          }`}
        />

        <div className="absolute inset-0 bg-white/90" />
        <div className="absolute inset-0 backdrop-blur-[1px]" />

        {/* DESKTOP */}
        <div className="hidden md:flex h-full items-center justify-center px-8 relative z-10">
          <div className="w-full max-w-[1200px] flex flex-col items-center justify-center text-center">
            <div className="flex-shrink-0 flex items-center justify-center gap-8 mb-8">
              <img
                src={SECOND_LOGO}
                alt="OGFZA Logo Two"
                className={`w-[180px] lg:w-[250px] object-contain ${
                  active ? "kb-zoom-soft" : ""
                }`}
              />

              <span className="h-[120px] w-[1.5px] bg-[#0b6b1d]" />

              <img
                src={LOGO_IMAGE}
                alt="OGFZA Logo One"
                className={`w-[180px] lg:w-[250px] object-contain ${
                  active ? "kb-zoom-soft" : ""
                }`}
              />
            </div>

            <div className="w-full flex flex-col items-center justify-center">
              <h2
                className="text-[#06183f] font-black text-[54px] lg:text-[72px] leading-none mb-4 text-center"
                style={{ fontFamily: "'Alegreya Sans', sans-serif" }}
              >
                Welcome to
              </h2>

              <h1
                className="text-[#1f9d4c] font-black leading-[0.98] tracking-[-2px] text-[42px] lg:text-[58px] text-center max-w-[900px]"
                style={{ fontFamily: "'Alegreya Sans', sans-serif" }}
              >
                OIL & GAS FREE
                <br />
                ZONES AUTHORITY
              </h1>

              <p className="mt-5 text-[#06183f] text-[17px] lg:text-[21px] font-medium max-w-[760px] leading-relaxed text-center">
                Promoting investment, regulating oil and gas free zones, and
                driving sustainable economic growth across Nigeria.
              </p>
            </div>
          </div>
        </div>

        {/* MOBILE */}
        <div className="md:hidden h-full flex flex-col items-center justify-center px-6 text-center relative z-10">
          <div className="flex items-center justify-center gap-4 mb-7">
            <img
              src={SECOND_LOGO}
              alt="OGFZA Logo Two"
              className={`w-[112px] sm:w-[135px] object-contain ${
                active ? "kb-zoom-soft" : ""
              }`}
            />

            <img
              src={LOGO_IMAGE}
              alt="OGFZA Logo One"
              className={`w-[112px] sm:w-[135px] object-contain ${
                active ? "kb-zoom-soft" : ""
              }`}
            />
          </div>

          <h2
            className="text-[#06183f] font-black text-[34px] leading-none mb-4 text-center"
            style={{ fontFamily: "'Alegreya Sans', sans-serif" }}
          >
            Welcome to
          </h2>

          <h1
            className="text-[#1f9d4c] font-black leading-[1] tracking-[-1px] text-[34px] text-center"
            style={{ fontFamily: "'Alegreya Sans', sans-serif" }}
          >
            OIL & GAS FREE
            <br />
            ZONES AUTHORITY
          </h1>

          <p className="mt-4 text-[#06183f] text-[14px] font-medium leading-relaxed max-w-[310px] text-center">
            Promoting investment and regulating Nigeria’s oil and gas free
            zones.
          </p>
        </div>
      </div>
    );
  }

  // ================= SECOND SLIDE =================
  if (slide.kind === "investor") {
    return (
      <div className="absolute inset-0 overflow-hidden">
        <img
          src={slide.image}
          alt="Become a Free Zone Investor"
          className={`w-full h-full object-cover object-center ${
            active ? "kb-zoom" : ""
          }`}
        />

        <div className="absolute inset-0 bg-black/30" />

        <div className="absolute inset-0 flex items-center">
          <div className="max-w-[1280px] mx-auto px-6 lg:px-12 w-full flex justify-center">
            <div className="text-center max-w-[920px]">
              <h1
                className="text-white font-black drop-shadow-2xl text-[44px] sm:text-[58px] md:text-[78px] lg:text-[92px] leading-[0.92] tracking-[-3px]"
                style={{ fontFamily: "'Alegreya Sans', sans-serif" }}
              >
                Become a
                <br />
                Free Zone Investor
              </h1>

              <Link
                to="/free-zones/registration-procedure"
                className="inline-flex items-center gap-2 mt-7 px-8 py-4 rounded-full bg-white text-[#06183f] hover:bg-[#1f9d4c] hover:text-white font-black text-[15px] md:text-[17px] shadow-2xl transition-all"
              >
                Get Started
                <ChevronRight size={20} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // ================= THIRD SLIDE =================
  if (slide.kind === "incentives") {
    return (
      <div className="absolute inset-0 overflow-hidden">
        <img
          src={slide.image}
          alt="A Variety of Incentives Await You"
          className={`w-full h-full object-cover object-center ${
            active ? "kb-zoom" : ""
          }`}
        />

        <div className="absolute inset-0 bg-black/30" />

        <div className="absolute inset-0 flex items-center">
          <div className="max-w-[1280px] mx-auto px-6 lg:px-12 w-full flex justify-center">
            <div className="text-center max-w-[1050px]">
              <h1
                className="text-white font-black drop-shadow-2xl text-[42px] sm:text-[56px] md:text-[76px] lg:text-[90px] leading-[0.92] tracking-[-3px]"
                style={{ fontFamily: "'Alegreya Sans', sans-serif" }}
              >
                A Variety of
                <br />
                Incentives Await You
              </h1>

              <Link
                to="/about/incentives"
                className="inline-flex items-center gap-2 mt-7 px-8 py-4 rounded-full bg-white text-[#06183f] hover:bg-[#1f9d4c] hover:text-white font-black text-[15px] md:text-[17px] shadow-2xl transition-all"
              >
                Learn More
                <ChevronRight size={20} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // ================= FOURTH SLIDE =================
  if (slide.kind === "md-message") {
    return (
      <div className="absolute inset-0 overflow-hidden bg-[#ececf5]">
        <img
          src={slide.image}
          alt="MD Message Background"
          className={`w-full h-full object-cover object-center scale-110 blur-[5px] ${
            active ? "kb-zoom-soft" : ""
          }`}
        />

        <div className="absolute inset-0 bg-black/55" />

        <div className="absolute inset-0 z-10 flex items-center justify-center px-6">
          <div className="w-full max-w-[1120px] grid md:grid-cols-[0.95fr_1.05fr] items-center gap-2 md:gap-4">
            <div className="text-center md:text-left order-2 md:order-1 md:translate-x-14 lg:translate-x-24">
              <h1
                className="text-white font-black drop-shadow-2xl text-[40px] md:text-[66px] lg:text-[82px] leading-[0.9] tracking-[-3px]"
                style={{ fontFamily: "'Alegreya Sans', sans-serif" }}
              >
                Managing Director’s
                <br />
                Message
              </h1>

              <Link
                to="/about/md-message"
                className="inline-flex items-center gap-2 mt-7 px-8 py-4 rounded-full bg-white text-[#06183f] hover:bg-[#1f9d4c] hover:text-white font-black text-[15px] md:text-[17px] shadow-2xl transition-all"
              >
                MD’s Message
                <ChevronRight size={20} />
              </Link>
            </div>

            <div className="flex justify-center md:justify-end order-1 md:order-2">
              <img
                src={MD_IMAGE}
                alt="Managing Director, OGFZA"
                className={`w-[220px] h-[280px] md:w-[360px] md:h-[460px] lg:w-[430px] lg:h-[550px] object-cover object-top rounded-[30px] shadow-2xl border-[6px] border-white ${
                  active ? "kb-zoom-soft" : ""
                }`}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="absolute inset-0 overflow-hidden">
      <img
        src={slide.image}
        alt="OGFZA"
        className={`w-full h-full object-cover object-center ${
          active ? "kb-zoom" : ""
        }`}
      />

      <div className="absolute inset-0 bg-black/30" />
    </div>
  );
};

const HeroSlider = () => {
  const [current, setCurrent] = useState(0);

  const filteredSlides = ogfzaSlides;

  const len = filteredSlides.length;

  const next = useCallback(() => {
    setCurrent((c) => (c + 1) % len);
  }, [len]);

  useEffect(() => {
    const id = setInterval(next, 7000);

    return () => clearInterval(id);
  }, [next]);

  return (
    <section className="relative overflow-visible bg-white">
      <div className="relative h-[520px] sm:h-[620px] md:h-[720px] lg:h-[820px]">
        {filteredSlides.map((slide, idx) => {
          const active = idx === current;

          return (
            <div
              key={slide.id}
              className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
                active ? "opacity-100 z-10" : "opacity-0 z-0"
              }`}
              aria-hidden={!active}
            >
              <SlideBackground slide={slide} active={active} />
            </div>
          );
        })}

        {/* ================= SLIDER CIRCLES ================= */}
        <div className="absolute left-1/2 -translate-x-1/2 -bottom-[42px] z-30 flex items-center gap-3 md:gap-4">
          {filteredSlides.map((s, i) => {
            const isCurrent = i === current;

            let thumbImage = s.image;

            if (s.kind === "full-logo") thumbImage = SECOND_LOGO;
            if (s.kind === "md-message") thumbImage = MD_IMAGE;

            return (
              <button
                key={s.id}
                onClick={() => setCurrent(i)}
                className={`overflow-hidden rounded-full transition-all duration-300 bg-white shadow-2xl flex items-center justify-center ${
                  isCurrent
                    ? "w-[82px] h-[82px] md:w-[96px] md:h-[96px] border-[4px] border-[#0d2d7a]"
                    : "w-[72px] h-[72px] md:w-[86px] md:h-[86px] border-[3px] border-white"
                }`}
                aria-label={`Go to slide ${i + 1}`}
              >
                <img
                  src={thumbImage}
                  alt=""
                  className="w-full h-full object-cover rounded-full"
                />
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HeroSlider;